// Headtouch – A Family Salon — content
export const SALON = {
  name: 'Headtouch',
  fullName: 'Headtouch – A Family Salon',
  tagline: 'A Family Salon',
  phone: '+91 77196 21840',
  phoneRaw: '+917719621840',
  whatsapp: '917719621840',
  address: 'SCO-1, Opp. Sushma Capital, Dhakoli, Zirakpur',
  addressLine1: 'SCO-1, Opp. Sushma Capital',
  addressLine2: 'Dhakoli, Zirakpur',
  addressLine3: 'Mohali, Punjab 160104',
  city: 'Dhakoli, Zirakpur',
  timing: 'Mon–Sun (Tue Off), 10 AM – 8 PM',
  timingShort: 'Mon–Sun (Tue Off)',
  timingHours: '10 AM – 8 PM',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=SCO-1+Opp+Sushma+Capital+Dhakoli+Zirakpur',
};

export const WHATSAPP_MSG = encodeURIComponent("Hi Headtouch! I'd like to book an appointment.");
export const whatsappLink = `https://wa.me/${SALON.whatsapp}?text=${WHATSAPP_MSG}`;
export const telLink = `tel:${SALON.phoneRaw}`;

// Services overview (Home page cards)
export const SERVICES_OVERVIEW = [
  {
    icon: 'Scissors',
    title: 'Haircuts & Styling',
    desc: 'Expert cuts and styling for the whole family',
  },
  {
    icon: 'Sparkles',
    title: 'Nail Services',
    desc: 'Premium nail extensions and artistic designs',
  },
  {
    icon: 'Heart',
    title: 'Facials & Skin Care',
    desc: 'Rejuvenating treatments for glowing skin',
  },
  {
    icon: 'Users',
    title: 'Grooming',
    desc: 'Professional grooming for men and women',
  },
];

// Full service pricing catalog
// Only these 4 items show prices. Everything else shows no price.
export const HAIR_SERVICES = [
  { name: "Men's Haircut", price: '₹150' },
  { name: "Women's Haircut", price: '₹350' },
  { name: 'Beard', price: '₹100' },
  { name: 'Root Touch Up', price: '₹500' },
  { name: 'Kids Haircut', price: null },
  { name: 'Hair Styling', price: null },
  { name: 'Hair Coloring', price: null },
  { name: 'Hair Spa', price: null },
  { name: 'Keratin Treatment', price: null },
  { name: 'Smoothening', price: null },
  { name: 'Head Massage', price: null },
  { name: 'Hair Wash', price: null },
];

export const NAIL_SERVICES = [
  { name: 'Basic Manicure', price: null, desc: 'Nail shaping, cuticle care, and polish' },
  { name: 'Basic Pedicure', price: null, desc: 'Foot soak, exfoliation, and polish' },
  { name: 'Gel Manicure', price: null, desc: 'Long-lasting gel polish with UV curing' },
  { name: 'Gel Pedicure', price: null, desc: 'Gel pedicure with chip-free finish' },
  { name: 'Acrylic Nails', price: null, desc: 'Durable acrylic nail enhancements' },
  { name: 'Nail Extensions', price: null, desc: 'Custom length and shape extensions' },
  { name: 'Nail Art (per nail)', price: null, desc: 'Custom designs and decorations' },
  { name: 'Nail Repair', price: null, desc: 'Fix broken or damaged nails' },
];

export const FACIAL_SERVICES = [
  { name: 'Classic Facial', price: null },
  { name: 'Gold Facial', price: null },
  { name: 'Diamond Facial', price: null },
  { name: 'Anti-Aging Facial', price: null },
  { name: 'Fruit Facial', price: null },
  { name: 'Clean Up', price: null },
  { name: 'Bleach', price: null },
  { name: 'D-Tan', price: null },
];

export const THREADING_SERVICES = [
  { name: 'Eyebrow Threading', price: null },
  { name: 'Upper Lip Threading', price: null },
  { name: 'Full Face Threading', price: null },
  { name: 'Waxing (Arms)', price: null },
  { name: 'Waxing (Legs)', price: null },
  { name: 'Waxing (Full Body)', price: null },
  { name: 'Face Wax', price: null },
];

export const GROOMING_SERVICES = [
  { name: "Men's Grooming Package", price: null },
  { name: "Women's Grooming Package", price: null },
  { name: 'Bridal Package', price: null },
  { name: 'Pre-Wedding Package', price: null },
  { name: 'Party Makeup', price: null },
];

export const TESTIMONIALS = [
  {
    name: 'Priya Sharma',
    service: 'Regular Customer',
    rating: 5,
    text: '"Friendly staff and professional work. Highly recommend for families!"',
  },
  {
    name: 'Rajesh Kumar',
    service: 'Haircut & Styling',
    rating: 5,
    text: '"The nail services here are exceptional. Best salon in Zirakpur."',
  },
  {
    name: 'Anjali Verma',
    service: 'Facial Services',
    rating: 5,
    text: '"Relaxing experience every time. Clean environment and skilled professionals."',
  },
  {
    name: 'Simran Kaur',
    service: 'Nail Art',
    rating: 5,
    text: '"The nail extensions here are absolutely stunning! They last for weeks and look so natural."',
  },
  {
    name: 'Vikram Singh',
    service: 'Grooming',
    rating: 5,
    text: '"The haircuts are always perfect. Highly recommend!"',
  },
  {
    name: 'Neha Singh',
    service: 'Nail Art',
    rating: 5,
    text: '"Best nail art in the area! The attention to detail is incredible. They really listen to what you want and deliver perfectly."',
  },
  {
    name: 'Pooja Gupta',
    service: 'Hair Spa',
    rating: 5,
    text: '"The hair spa treatment was so relaxing! My hair feels healthier and looks shinier. Great experience overall."',
  },
  {
    name: 'Sandeep Bhatia',
    service: 'Shaving',
    rating: 5,
    text: '"Clean salon with professional staff. The shaving service is excellent - smooth and comfortable. Highly recommend this place."',
  },
  {
    name: 'Amit Malhotra',
    service: 'Family Services',
    rating: 5,
    text: '"I bring my whole family here. Everyone always leaves happy! Great prices and excellent service. The staff is very friendly."',
  },
];

export const VALUES = [
  { icon: 'Users', title: 'Professional Staff', desc: 'Trained and experienced professionals dedicated to your satisfaction' },
  { icon: 'Award', title: 'Quality Service', desc: 'Premium services delivered with meticulous care and attention' },
  { icon: 'Sparkles', title: 'Clean & Hygienic', desc: 'We maintain the highest standards of cleanliness and hygiene. All tools are properly sanitized and we follow strict safety protocols.' },
  { icon: 'Heart', title: 'Friendly Environment', desc: 'Our warm and welcoming atmosphere makes every visit comfortable. We treat every client like family.' },
  { icon: 'Gem', title: 'Premium Products', desc: 'We use only high-quality, trusted brands to ensure your hair, skin, and nails receive the best care.' },
  { icon: 'GraduationCap', title: 'Skilled Professionals', desc: 'Our team stays updated with the latest trends and techniques to give you the best possible results.' },
];

export const WHY_CHOOSE = [
  'Friendly & Professional Staff',
  'Clean & Hygienic Environment',
  'Attention to Detail',
  'Comfortable Experience',
];

export const WHY_NAIL = [
  { icon: 'CheckCircle2', title: 'Hygienic Tools & Equipment' },
  { icon: 'CheckCircle2', title: 'Custom Nail Art Designs' },
  { icon: 'CheckCircle2', title: 'Long-Lasting Results' },
  { icon: 'CheckCircle2', title: 'Relaxing Experience' },
];

export const FAMILY_TRUST = [
  { icon: 'Heart', title: 'Trust & Comfort', desc: 'Building lasting relationships with our clients through genuine care and attention' },
  { icon: 'CheckCircle2', title: 'Consistency', desc: 'Delivering excellent service every time you visit us' },
];

export const GALLERY_IMAGES = [
  { src: '/images/salon-wide.jpg', tag: 'Interior', alt: 'Salon interior with styling chairs' },
  { src: '/images/salon-entrance.jpg', tag: 'Reception', alt: 'Salon entrance and lounge' },
  { src: '/images/salon-chairs.jpg', tag: 'Styling Area', alt: 'Styling chairs and mirrors' },
  { src: '/images/salon-collage.jpg', tag: 'Full View', alt: 'Salon full view' },
];

export const IMAGES = {
  hero: '/images/salon-wide.jpg',
  about: '/images/salon-entrance.jpg',
  whyChoose: '/images/salon-chairs.jpg',
  contact: '/images/salon-collage.jpg',
};
